import Typography from "@components/Typography";

import Message from "./Message";

import styles from "./Message.module.css";

const Empty = () => {
  return (
    <Message data-testid="empty-search-message">
      <Typography variant="h2" align="center">
        {L.ALERT_NO_MENTIONS_YET}
      </Typography>
      <div>
        <Typography variant="subtitle-1" align="center" margin="none">
          {L.ALERT_NO_MENTIONS_YET_SUB}
        </Typography>
        <Typography
          align="center"
          className={styles.dim}
          dangerouslySetInnerHTML={{ __html: L.ALERT_NO_MENTIONS_LINK }}
        />
      </div>
    </Message>
  );
};
export default Empty;
